import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainComponent } from './components/main/main.component';
import { ReservationDetailsComponent } from './components/reservation-details/reservation-details.component';

const routes: Routes = [
  { path: '', component: MainComponent },
  { path: 'confirm', component: MainComponent },
  { path: 'details/:id', component: ReservationDetailsComponent },
  { path: 'delete/:id', component: ReservationDetailsComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }